import React from "react";
import { Link } from "react-router-dom";
import "./CSS/home.css";
import { FaFacebook, FaLinkedin, FaXTwitter } from "react-icons/fa6";
function Footer() {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        <div className="footer-section footer-brand">
          <h3 className="footer-logo">CircleGrid</h3>
          <p className="footer-tagline">
            Build your website. Find your audience. Grow your business.
          </p>
        </div>

        <div className="footer-section footer-links">
          <h4 className="footer-heading">Quick Links</h4>
          <ul className="footer-nav">
            <li>
              <Link to="/Signup" className="footer-link">
                Sign up
              </Link>
            </li>
            <li>
              <a
                href="/Directory"
                target="_blank"
                rel="noreferrer"
                className="footer-link"
              >
                Directory
              </a>
            </li>
            <li>
              <Link to="/TermsAndConditions" className="footer-link">
                Terms And Conditions
              </Link>
            </li>
            <li>
              <Link to="/ContactPage" className="footer-link">
                Contact Us
              </Link>
            </li>
            <li>
              <Link to="/track-order" className="footer-link">
                Track an order
              </Link>
            </li>
          </ul>
        </div>

        <div className="footer-section footer-social">
          <h4 className="footer-heading">Connect With Us</h4>
          <div className="social-links">
            <a
              href="https://www.facebook.com/share/16vXKkUF9c/"
              target="_blank"
              rel="noreferrer"
              className="social-link"
              aria-label="Facebook"
            >
              <FaFacebook className="social-icon" />
            </a>
            <a
              href="https://za.linkedin.com/company/circlegrid-business-network?trk=public_profile_topcard-current-company/"
              target="_blank"
              rel="noreferrer"
              className="social-link"
              aria-label="LinkedIn"
            >
              <FaLinkedin className="social-icon" />
            </a>
            {/* <a
              href="https://x.com/FilingStack?s=20"
              target="_blank"
              rel="noreferrer"
              className="social-link"
              aria-label="X (Twitter)"
            >
              <FaXTwitter className="social-icon" />
            </a> */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            © {new Date().getFullYear()} CircleGrid. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
